import { WithdrawalType } from "../../../constants";

interface WithdrawalTypeTabSwitcherProps {
  withdrawalType: WithdrawalType;
  handleWithdrawalTypeChange: (withdrawalType: WithdrawalType) => void;
}

export default function WithdrawalTypeTabSwitcher({
  withdrawalType,
  handleWithdrawalTypeChange,
}: WithdrawalTypeTabSwitcherProps) {
  return (
    <div className="flex rounded-full bg-gray-200 p-1 mb-6">
      <button
        type="button"
        onClick={() => handleWithdrawalTypeChange(WithdrawalType.INTERNATIONAL)}
        className={`flex-1 py-3 px-6 rounded-full text-sm font-medium ${
          withdrawalType === WithdrawalType.INTERNATIONAL
            ? "bg-white text-green-600 shadow"
            : "text-gray-500"
        }`}
      >
        International
      </button>
      <button
        type="button"
        onClick={() => handleWithdrawalTypeChange(WithdrawalType.LOCAL)}
        className={`flex-1 py-3 px-6 rounded-full text-sm font-medium ${
          withdrawalType === WithdrawalType.LOCAL
            ? "bg-white text-green-600 shadow"
            : "text-gray-500"
        }`}
      >
        Local Transfer
      </button>
    </div>
  );
}
